import { I as t } from "../../iconLoader.gen-s7HkRuDe.js";
function o(r) {
  return typeof r == "string" && r in t;
}
export {
  o as isIconName
};
